(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-equipment-calculator"] && !Shopify.designMode) return;
  try {
    
(() => {
  const roots = document.querySelectorAll('[data-asivana-studio-calculator]');
  roots.forEach((root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const roomList = root.querySelector('[data-room-list]');
    const roomTemplate = root.querySelector('[data-room-template]');
    const zoneTemplate = root.querySelector('[data-zone-template]');
    const sharing = root.querySelector('[data-sharing]');
    const results = root.querySelector('[data-results]');
    const validation = root.querySelector('[data-validation]');
    let roomCounter = 0;

    const money = (cents) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format((Number(cents) || 0) / 100);
    const clampNumber = (value, min, max) => {
      const n = Number(value);
      if (!Number.isFinite(n)) return null;
      return Math.min(max, Math.max(min, n));
    };
    const capacity1D = (room, mat, gap) => Math.max(0, Math.floor((room + gap) / (mat + gap)));
    const rectangleCapacity = (lengthIn, widthIn, matLength, matWidth, gap) => {
      const aRows = capacity1D(lengthIn, matLength, gap);
      const aCols = capacity1D(widthIn, matWidth, gap);
      const bRows = capacity1D(lengthIn, matWidth, gap);
      const bCols = capacity1D(widthIn, matLength, gap);
      const a = aRows * aCols;
      const b = bRows * bCols;
      if (b > a) return { capacity: b, orientation: `${matWidth}\" × ${matLength}\" orientation` };
      return { capacity: a, orientation: `${matLength}\" × ${matWidth}\" orientation` };
    };
    const lShapeCapacity = (outerL, outerW, cutL, cutW, matL, matW, gap) => {
      if (cutL >= outerL || cutW >= outerW) return { capacity: 0, orientation: 'Check the missing-corner dimensions' };
      const splitA1 = rectangleCapacity(outerL - cutL, outerW, matL, matW, gap).capacity;
      const splitA2 = rectangleCapacity(cutL, outerW - cutW, matL, matW, gap).capacity;
      const splitB1 = rectangleCapacity(outerL, outerW - cutW, matL, matW, gap).capacity;
      const splitB2 = rectangleCapacity(outerL - cutL, cutW, matL, matW, gap).capacity;
      const a = splitA1 + splitA2;
      const b = splitB1 + splitB2;
      return { capacity: Math.max(a, b), orientation: 'L-shape optimized across rectangular sections' };
    };

    const addZone = (room) => {
      const node = zoneTemplate.content.firstElementChild.cloneNode(true);
      node.querySelector('[data-remove-zone]').addEventListener('click', () => {
        if (room.querySelectorAll('[data-zone]').length <= 1) return;
        node.remove();
        updateAdvancedRoom(room);
      });
      node.querySelectorAll('input').forEach((input) => input.addEventListener('input', () => updateAdvancedRoom(room)));
      room.querySelector('[data-zone-list]').appendChild(node);
    };

    const readZoneCapacity = (room, gap, matL, matW) => {
      let total = 0;
      let valid = true;
      room.querySelectorAll('[data-zone]').forEach((zone) => {
        const l = clampNumber(zone.querySelector('[data-zone-length]').value, 0.5, 500);
        const w = clampNumber(zone.querySelector('[data-zone-width]').value, 0.5, 500);
        if (l === null || w === null) { valid = false; return; }
        total += rectangleCapacity(l * 12, w * 12, matL, matW, gap).capacity;
      });
      return valid ? total : null;
    };

    const getAdvancedCapacity = (room, gap) => {
      const shape = room.querySelector('[data-shape]').value;
      const matL = clampNumber(room.querySelector('[data-mat-length]').value, 48, 120);
      const matW = clampNumber(room.querySelector('[data-mat-width]').value, 18, 60);
      if (matL === null || matW === null) return null;

      let result = null;
      if (shape === 'rectangle') {
        const l = clampNumber(room.querySelector('[data-length]').value, 1, 500);
        const w = clampNumber(room.querySelector('[data-width]').value, 1, 500);
        if (l === null || w === null) return null;
        result = rectangleCapacity(l * 12, w * 12, matL, matW, gap);
      } else if (shape === 'lshape') {
        const outerL = clampNumber(room.querySelector('[data-outer-length]').value, 1, 500);
        const outerW = clampNumber(room.querySelector('[data-outer-width]').value, 1, 500);
        const cutL = clampNumber(room.querySelector('[data-cut-length]').value, 0.1, 500);
        const cutW = clampNumber(room.querySelector('[data-cut-width]').value, 0.1, 500);
        if ([outerL, outerW, cutL, cutW].some((v) => v === null)) return null;
        result = lShapeCapacity(outerL * 12, outerW * 12, cutL * 12, cutW * 12, matL, matW, gap);
      } else {
        const cap = readZoneCapacity(room, gap, matL, matW);
        if (cap === null) return null;
        result = { capacity: cap, orientation: 'Custom rectangular sections calculated independently' };
      }
      if (room.querySelector('[data-instructor]').checked) result.capacity = Math.max(0, result.capacity - 1);
      return result;
    };

    const updateAdvancedRoom = (room) => {
      const gap = Number(room.querySelector('[data-spacing]').value);
      const tolerance = gap * 0.25;
      const lowGap = Math.max(0, gap - tolerance);
      const highGap = gap + tolerance;
      const planned = getAdvancedCapacity(room, gap);
      const tight = getAdvancedCapacity(room, lowGap);
      const conservative = getAdvancedCapacity(room, highGap);
      const calcBox = room.querySelector('[data-room-calculation]');
      const spacingName = gap === 4 ? 'Small' : gap === 24 ? 'Large' : 'Medium';
      room.querySelector('[data-spacing-note]').textContent = `${spacingName} spacing uses ${gap} inches between mat edges, with a ${lowGap}–${highGap} inch tolerance range.`;

      if (!planned || !tight || !conservative || planned.capacity < 1) {
        calcBox.hidden = true;
        return;
      }
      room.querySelector('[data-planned-capacity]').textContent = planned.capacity;
      room.querySelector('[data-capacity-range]').textContent = `Estimated range: ${conservative.capacity}–${tight.capacity} mats.`;
      room.querySelector('[data-orientation]').textContent = planned.orientation;
      calcBox.hidden = false;
      room.querySelector('[data-manual-capacity]').value = planned.capacity;
    };

    const updateShapeFields = (room) => {
      const shape = room.querySelector('[data-shape]').value;
      room.querySelector('[data-rectangle-fields]').hidden = shape !== 'rectangle';
      room.querySelector('[data-lshape-fields]').hidden = shape !== 'lshape';
      room.querySelector('[data-custom-fields]').hidden = shape !== 'custom';
      if (shape === 'custom' && room.querySelectorAll('[data-zone]').length === 0) addZone(room);
      updateAdvancedRoom(room);
    };

    const updateSharingVisibility = () => {
      const count = roomList.querySelectorAll('[data-room]').length;
      sharing.hidden = count < 2;
      roomList.querySelectorAll('[data-remove-room]').forEach((button) => { button.hidden = count < 2; });
    };

    const addRoom = () => {
      roomCounter += 1;
      const room = roomTemplate.content.firstElementChild.cloneNode(true);
      room.querySelector('[data-room-name]').value = `Room ${roomCounter}`;
      room.querySelector('[data-remove-room]').addEventListener('click', () => {
        room.remove();
        updateSharingVisibility();
      });
      room.querySelector('[data-shape]').addEventListener('change', () => updateShapeFields(room));
      room.querySelector('[data-spacing]').addEventListener('change', () => updateAdvancedRoom(room));
      room.querySelector('[data-instructor]').addEventListener('change', () => updateAdvancedRoom(room));
      room.querySelector('[data-add-zone]').addEventListener('click', () => addZone(room));
      room.querySelectorAll('[data-advanced] input[type="number"]').forEach((input) => input.addEventListener('input', () => updateAdvancedRoom(room)));
      room.querySelector('[data-advanced]').addEventListener('toggle', () => {
        if (room.querySelector('[data-advanced]').open) updateAdvancedRoom(room);
      });
      roomList.appendChild(room);
      updateShapeFields(room);
      updateSharingVisibility();
      return room;
    };

    const equipment = [
      { name: 'Yoga mats', rate: 1 },
      { name: 'Yoga blocks', rate: 2 },
      { name: 'Yoga straps', rate: 1 },
      { name: 'Yoga sandbags', rate: 2 },
      { name: 'Yoga blankets', rate: 1 },
      { name: 'Yoga bolsters', rate: 1 }
    ];

    const optimizeBlocksAndStraps = (blocksNeeded, strapsNeeded) => {
      const comboPrice = Number(root.dataset.comboPrice) || 0;
      const blockPrice = Number(root.dataset.blockPrice) || 0;
      const strapPrice = Number(root.dataset.strapPrice) || 0;
      if (!comboPrice || !blockPrice || !strapPrice) return null;
      let best = null;
      const maxCombo = Math.ceil(blocksNeeded / 8) + Math.ceil(strapsNeeded / 4) + 2;
      for (let combo = 0; combo <= maxCombo; combo += 1) {
        const remBlocks = Math.max(0, blocksNeeded - combo * 8);
        const remStraps = Math.max(0, strapsNeeded - combo * 4);
        const blockBundles = Math.ceil(remBlocks / 8);
        const strapBundles = Math.ceil(remStraps / 16);
        const total = combo * comboPrice + blockBundles * blockPrice + strapBundles * strapPrice;
        const coverageBlocks = combo * 8 + blockBundles * 8;
        const coverageStraps = combo * 4 + strapBundles * 16;
        if (!best || total < best.total || (total === best.total && coverageBlocks + coverageStraps < best.coverageBlocks + best.coverageStraps)) {
          best = { combo, blockBundles, strapBundles, total, coverageBlocks, coverageStraps };
        }
      }
      return best;
    };

    const renderDeals = (recommended) => {
      const box = root.querySelector('[data-deal-recommendation]');
      const best = optimizeBlocksAndStraps(recommended.blocks, recommended.straps);
      const sandbagPrice = Number(root.dataset.sandbagPrice) || 0;
      const sandbagBundles = sandbagPrice ? Math.ceil(recommended.sandbags / 12) : 0;
      if (!best && !sandbagBundles) { box.innerHTML = ''; return; }
      let items = '';
      if (best) {
        if (best.combo) items += `<li>${best.combo} × <a href="${root.dataset.comboUrl}">8-block + 4-strap studio kit</a></li>`;
        if (best.blockBundles) items += `<li>${best.blockBundles} × <a href="${root.dataset.blockUrl}">8-pack cork block bundle</a></li>`;
        if (best.strapBundles) items += `<li>${best.strapBundles} × <a href="${root.dataset.strapUrl}">16-strap studio bundle</a></li>`;
      }
      if (sandbagBundles) items += `<li>${sandbagBundles} × <a href="${root.dataset.sandbagUrl}">12-sandbag studio bundle</a></li>`;
      const total = (best ? best.total : 0) + sandbagBundles * sandbagPrice;
      box.innerHTML = `<h3>Current Asivana bundle mix</h3><p>One cost-efficient way to cover the calculated block, strap, and sandbag quantities with current studio bundles is:</p><ul>${items}</ul><p class="asc-deal-total">Estimated bundle subtotal: ${money(total)}</p><small>Bundle subtotal does not include mats, blankets, bolsters, taxes, or shipping. Product prices and availability can change.</small>`;
    };

    const calculate = () => {
      validation.textContent = '';
      const rooms = Array.from(roomList.querySelectorAll('[data-room]'));
      const capacities = rooms.map((room) => {
        const name = room.querySelector('[data-room-name]').value.trim() || 'Room';
        const capacity = clampNumber(room.querySelector('[data-manual-capacity]').value, 1, 500);
        return { name, capacity: capacity === null ? null : Math.floor(capacity) };
      });
      if (capacities.some((r) => r.capacity === null)) {
        validation.textContent = 'Enter the number of student mats that fit in each room, or use the advanced room calculator.';
        results.hidden = true;
        return;
      }
      const sharingMode = root.querySelector('input[name="asc-sharing-mode"]:checked')?.value || 'simultaneous';
      const totalCapacity = sharingMode === 'shared'
        ? Math.max(...capacities.map((r) => r.capacity))
        : capacities.reduce((sum, r) => sum + r.capacity, 0);
      const resultCapacity = root.querySelector('[data-result-capacity]');
      resultCapacity.textContent = totalCapacity;
      const context = root.querySelector('[data-result-context]');
      if (capacities.length === 1) {
        context.textContent = `${capacities[0].name}: planning for ${totalCapacity} student spaces.`;
      } else if (sharingMode === 'shared') {
        context.textContent = `Props are planned for the largest room (${totalCapacity} students) because equipment can be shared between rooms.`;
      } else {
        context.textContent = `Props are planned for ${totalCapacity} students across ${capacities.length} rooms that may operate at the same time.`;
      }

      const recommended = {};
      const grid = root.querySelector('[data-equipment-grid]');
      grid.innerHTML = equipment.map((item) => {
        const minimum = totalCapacity * item.rate;
        const rec = Math.ceil(minimum * 1.2);
        if (item.name === 'Yoga blocks') recommended.blocks = rec;
        if (item.name === 'Yoga straps') recommended.straps = rec;
        if (item.name === 'Yoga sandbags') recommended.sandbags = rec;
        return `<div class="asc-equipment-card"><h3>${item.name}</h3><div class="asc-equipment-counts"><div><strong>${minimum}</strong><small>minimum</small></div><div><strong>${rec}</strong><small>recommended +20%</small></div></div></div>`;
      }).join('');
      renderDeals(recommended);
      results.hidden = false;
      if (window.matchMedia('(max-width: 900px)').matches) results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    root.querySelector('[data-add-room]').addEventListener('click', addRoom);
    root.querySelector('[data-calculate]').addEventListener('click', calculate);
    root.querySelectorAll('input[name="asc-sharing-mode"]').forEach((input) => input.addEventListener('change', () => {
      if (!results.hidden) calculate();
    }));

    addRoom();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
